import React from 'react';
import { connect } from 'react-redux';
import root from 'window-or-global';
import ia from 'config/Analytics';
import Loading from 'views/Loading';

import { getFormattedDateWithTime } from 'config/utils';

import {
  retryFailedPayment,
} from '../../actions/PostPurchaseActions';

const FailureResponse = ({
  payment,
  retryFailedPayment,
  isRetryEnabled,
  hasFailureRedirection,
}) => (
  <div className="font-rc">
    <div className="center">
      { root.redirectUrl && root.redirectionDelay ?
        <Loading className="pace-loading huge slow"/> :
        null
      }
      <h3 className="center text-red soft-half--top font-rc">Payment Failed!</h3>
      { root.redirectUrl && root.redirectionDelay ?
        <p className="text-bold"> Please wait while we redirect you... </p> :
        null
      }
    </div>
      <hr style={{ margin: '10px 0' }}/>
      <p className="text-medium soft-half--sides">
        <span className="text-bold">Don't worry your money is safe! </span> If money was debited from your account, it will be refunded automatically in 5-7 working days.</p>
      <hr style={{ margin: '10px 0' }}/>
      <table className="table-compact table-vertical-center table-colorless text-medium soft-half--sides" style={{ width: '100%' }}>
        <tbody>
          <tr>
            <td className="text-bold" >Payment ID</td>
            <td className="float--right">{payment.paymentId}</td>
          </tr>
          <tr>
            <td className="text-bold">Time</td>
            <td className="float--right">{getFormattedDateWithTime(new Date())}</td>
          </tr>
        </tbody>
      </table>
      <hr style={{ margin: '10px 0' }}/>
      <p className="text-bold text-medium soft-half--sides">Why did it fail?</p>
      <ol className="soft--left push-half--left soft--bottom text-medium">
        <li>The CVV or Expiry Date might be wrong.</li>
        <li>Your Bank network might be down.</li>
      </ol>
      { isRetryEnabled ?
        <div>
          <button
            className="btn-green btn-block"
            type="button"
            onClick={() => {
              retryFailedPayment();
              ia.sendEvent('Retried Payment', {
                'buyer_email': payment.buyer.email,
                'amount': payment.link.amount,
                'purpose': payment.link.title,
                'payment_id': payment.paymentId,
                'seller_username': payment.seller.username,
                'seller_email': payment.seller.email,
                'order_id' : payment.orderId,
              });
            }}>
            Retry
          </button>
          { hasFailureRedirection ?
            <div className="text-center push--top push-half--bottom">
              <span>or</span>
              <a className="push-half--left caps"
                onClick={root.processCancel}>
                Cancel
              </a>
            </div> :
            null
          }
        </div> :
        null
      }
    </div>
);

const mapStateToProps = ({ settings }) => ({
  isRetryEnabled: settings.isRetryEnabled,
  hasFailureRedirection: settings.hasFailureRedirection,
});

export default connect(mapStateToProps, {
  retryFailedPayment,
})(FailureResponse);



// WEBPACK FOOTER //
// ./src/payments/views/post-purchase/FailureResponse.js